<template>
  <div class="main">
    <div style="width: 100%;">
      <van-notice-bar scrollable
                      left-icon="volume-o"
                      text="尊敬的用户您好，请您认真填写个人信息，这样我们才能提供更精准的服务！"
      />
    </div>
    <van-form style="width: 96%;margin-top: 1rem;" ref="formRef">
      <van-field
          v-model="param.nickname"
          label="昵称"
          @blur="nameValidate"
          :error-message="nickNameErrorMessage"
          placeholder="昵称"/>
      <van-field required
                 v-model="param.name"
                 label="姓名（必）"
                 placeholder="请填写身份证上的姓名"
                 @blur="nameValidate"
                 :error-message="nameErrorMessage"
                 :disabled="isEditName"
                 :rules="[{ required: true, message: '请填写姓名' }]"/>
      <van-field name="radio" label="性别（必）">
        <template #input>
          <van-radio-group v-model="param.sexid" direction="horizontal" :disabled="isEditSexid">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
            <van-radio name="0" disabled>未说明</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field name="radio" label="婚姻（选）">
        <template #input>
          <van-radio-group v-model="param.marital" direction="horizontal" :disabled="isEditMarital">
            <van-radio name="0">未婚</van-radio>
            <van-radio name="1">已婚</van-radio>
            <van-radio name="3" disabled>未说明</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field required v-model="param.phone"
                 type="tel"
                 label="手机号（必）"
                 placeholder="手机号"
                 :rules="[{ required: true, message: '请填写手机号' }]"
                 :error-message="phoneErrorMessage"
                 @blur="phonevalidate"
                 :disabled="isEditPhone"
      />
      <van-field required v-model="param.cardid"
                 type="text"
                 :label="`${cardidTypeText}（必）`"
                 :placeholder="cardidTypeText"
                 :rules="[{ required: true, message: cardidTypeText }]"
                 :error-message="idcardErrorMessage"
                 @blur="idvalidate"
                 :disabled="isEditCardId"
      >
        <template #button>
          <van-button size="small" style="cursor: none" type="info" @click.stop="changeCardidType">
            <van-icon name="exchange"/>
            换
          </van-button>
        </template>
      </van-field>
      <van-field v-if="cardidTypeText =='身份证'?false:true"
                 required
                 v-model="param.birthdate"
                 label="生日（必填）"
                 placeholder="生日"
                 @click="showAge = true"
                 :disabled="cardidTypeText =='身份证'?true:false"
                 :rules="[{ required: true, message: '请选择生日' }]"/>
      <van-field
          v-model="param.password"
          :type="passwordType"
          name="密码"
          label="密码（选）"
          placeholder="登录密码"
          :right-icon="passwordIcon"
          @click-right-icon="changeToText"
      />
      <van-field v-model="param.address" type="text" label="地址（选）" placeholder="请填写现居住地址"/>
      <!--      <van-field v-model="param.natives" type="text" label="籍贯（选填）" placeholder="请选择籍贯" disabled-->
      <!--                 @click="showNative = true"/>-->
      <!--信息确认提示信息-->
      <van-notice-bar
          wrapable
          v-if="infoCheckTips"
          :scrollable="false"
          color="#ff6c6c" background="#fff6f6" left-icon="info-o"
          text="请确认以上信息，提交后再进行预约"
      />
      <div class="footer">
        <van-button round block @click="onSubmit"
                    color="linear-gradient(to right, #10E3E9, #409EFF)"
                    style="margin-top: 5rem;">提 交
        </van-button>
      </div>
    </van-form>
    <div style="width: 96%;">
      <div class="footer">
        <van-button round block v-if="type == 'editRelative'" @click="del"
                    style="margin-top: 1rem;">移 除
        </van-button>
      </div>
    </div>
    <van-popup v-model="showAge" round position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
          v-model="date"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="timeFormat"
          @cancel="showAge = false"
      />
    </van-popup>

    <van-popup v-model="showNative" round position="bottom" :style="{ height: '40%' }">
      <van-area title="请选择籍贯"
                :value="areaCode"
                :area-list="areaList"
                @confirm="selectArea"
                @cancel="showNative = false"/>
    </van-popup>
    <van-action-sheet title="选择证件类型" v-model="cardidTypeSelectShow" :actions="cardidTypeTextActions"
                      @select="onSelectCardidType"/>
  </div>
</template>

<script>
import {areaList} from '@vant/area-data';
import {
  getUserInfoByPatientid,
  editUserInfo,
  getRelativesByIdCard,
  editRelatives,
  deleteRelatives

} from '@/api/module/user'
import {Toast, Dialog} from "vant";
import {decrypt, encrypt} from '../../assets/utils/cryptoUtil.js'
import {getBirthdayByIdCard} from "@/assets/utils/utils";

export default {
  name: "index",
  data() {
    return {
      phoneErrorMessage: '',//手机号格式错误
      passwordErrorMessage: '',//密码由6位以上的数字与字符组成
      idcardErrorMessage: '',//身份证号码不正确
      date: '',
      areaCode: '',
      areaList,
      showAge: false,
      showNative: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      param: {
        name: '',
        sexid: '',
        marital: '',
        phone: '',
        password: '',
        cardid: '',
        birthdate: '',
        address: '',
      },
      phoneDisabled: true,
      type: 'editSelf',
      phone: window.g.VUE_APP_PHONE,
      passComplex: window.g.VUE_APP_PASS_COMPLEX,
      cardidTypeText: '身份证',
      cardidTypeTextActions: [{name: '身份证'}, {name: '护照'}],
      cardidTypeSelectShow: false,
      nickNameErrorMessage: '',
      nameErrorMessage: '',
      isEditSexid: true,
      isEditMarital: true,
      isEditPhone: true,
      isEditName: true,
      isEditCardId: true,
      passwordType: "password",
      passwordIcon: "eye-o",
      infoCheckTips: false,
    };
  },
  created() {
    //1、如果是亲属，则根据身份证号码查询用户信息
    //2、登录用户则根据手机号码查询
    let idcard = this.$route.query.idcard
    let sourcePage = this.$route.query.sourcePage
    // 如果是单位预约跳转过来的则需要返回到列表页再重新进入到详情页 2025-11-5 zls
    if (sourcePage == "company") {
      this.infoCheckTips = true
    }
    if (idcard != undefined) {
      if (idcard != '') {
        this.getRelative(idcard)
        this.type = 'editRelative'
        this.phoneDisabled = true
        document.title = "编辑家庭成员信息"
      }
    } else {
      this.getUserInfo()
      this.type = 'editSelf'
      this.phoneDisabled = true
      document.title = "编辑帐号信息"
    }
  },
  methods: {
    changeToText() {
      console.log("this.passwordType", this.passwordType)
      if (this.passwordType === "password") {
        this.passwordType = "text"
        this.passwordIcon = "browsing-history-o"
      } else {
        this.passwordType = "password"
        this.passwordIcon = "eye-o"
      }
    },
    changeCardidType() {
      this.cardidTypeSelectShow = true
    },
    onSelectCardidType(item) {
      this.cardidTypeText = item.name
      this.cardidTypeSelectShow = false
    },
    getRelative(idcard) {
      let param = {
        idcard: encrypt(idcard)
      }
      getRelativesByIdCard(param).then(res => {
        if (res.code == 200) {
          this.param = res.data
          this.$nextTick(function () {
            if (this.param.password) {
              this.param.password = decrypt(this.param.password)
            }
            if (this.param.birthday) {
              this.param.birthdate = this.param.birthdate.substring(0, 10)
            }
            this.setIsEdit()
          })
        }
      })
    },
    // 设置是否可编辑
    setIsEdit() {
      // 2025-08-18 luotong 控制如果姓名、手机号、身份证不为空则不能修改
      if (!this.param.name) {
        this.isEditName = false
      }
      if (!this.param.sexid || this.param.sexid == '0') {
        this.isEditSexid = false
      }
      if (!this.param.marital || this.param.marital == '3') {
        this.isEditMarital = false
      }
      if (!this.param.phone) {
        this.isEditPhone = false
      }
      if (!this.param.cardid) {
        this.isEditCardId = false
      }
    },
    getUserInfo() {
      let param = {
        patientid: this.$encruption(JSON.parse(localStorage.getItem("loginuser")).patientid)
      }
      getUserInfoByPatientid(param).then(res => {
        if (res.code == 200) {
          if (res.data == -1) {
            if (res.msg == "参数patientid错误") {
              Dialog({
                message: "登录过期，返回重新登录",
                theme: 'round-button',
              }).then(() => {
                window.localStorage.removeItem("loginuser")
                localStorage.removeItem("token")
                this.$router.push({name: 'login'})
              });
            } else {
              Dialog({
                message: res.msg + ',请立即联系体检中心处理，电话：' + this.phone,
                theme: 'round-button',
              });
            }
          } else {
            this.$nextTick(function () {
              this.param = res.data
              if (this.param.name) {
                this.param.name = decrypt(this.param.name)
              }

              if (this.param.cardid) {
                this.param.cardid = decrypt(this.param.cardid)
              }

              if (this.param.phone) {
                this.param.phone = decrypt(this.param.phone)
              }

              if (this.param.address) {
                this.param.address = decrypt(this.param.address)
              }

              if (this.param.birthdate) {
                this.param.birthdate = this.param.birthdate.substring(0, 10)
              }
              this.setIsEdit()
            })
          }
        }
      })
    },
    edit() {
      if (this.param.sexid == "0") {
        Toast.fail("请设置正确的性别");
        return;
      }
      if (this.type == 'editSelf') {
        let opneid = ''
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        if (userinfo) {
          opneid = userinfo.opneid
          if (opneid != '' && opneid != undefined) {
            this.param.opneid = opneid
          }
        }
        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.cardid = encrypt(newParam.cardid)
        newParam.phone = encrypt(newParam.phone)
        newParam.password = encrypt(newParam.password)
        newParam.patientid = JSON.parse(localStorage.getItem("loginuser")).patientid
        editUserInfo(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
            } else {
              let param = this.param

              param.name = encrypt(this.param.name)
              param.cardid = encrypt(this.param.cardid)
              param.phone = encrypt(this.param.phone)

              localStorage.setItem("loginuser", JSON.stringify(param))
              Toast.success('修改成功！');
              if (this.infoCheckTips) {
                this.$router.push({name: 'companyOrders'})
              } else {
                this.$router.go(-1);//返回上一层
              }
            }
          }
        })
      } else if (this.type == 'editRelative') {
        // this.param.phone = '';
        // this.param.password = '';
        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.patientid = encrypt(newParam.patientid)
        newParam.cardid = encrypt(newParam.cardid)
        newParam.phone = encrypt(newParam.phone)
        newParam.password = encrypt(newParam.password)
        editRelatives(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
            } else {
              Toast.success('修改成功！');
              this.$router.go(-1);//返回上一层
            }
          }
        })
      }
    },
    phonevalidate() {
      //手机号码校验 phoneErrorMessage
      // eslint-disable-next-line no-unreachable
      let myreg = /^((0\d{2,3}-\d{7,8})|(0\d{2,3}\d{7,8})|(\d{7,8})|(1[3456789]\d{9}))$/
      if (!myreg.test(this.param.phone)) {
        this.phoneErrorMessage = '请填写正确的手机号码'
        return false;
      } else {
        this.phoneErrorMessage = ''
        return true;
      }
    },
    idvalidate() {
      if (this.cardidTypeText == "身份证") {
        //身份证校验
        // eslint-disable-next-line no-unreachable
        let myreg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (!myreg.test(this.param.cardid)) {
          this.idcardErrorMessage = '请填写正确的身份证号码'
          return false;
        } else {
          this.idcardErrorMessage = ''
          this.param.birthdate = getBirthdayByIdCard(this.param.cardid)
          return true;
        }
      } else if (this.cardidTypeText == "护照") {
        if (this.param.cardid.length <= 0) {
          this.idcardErrorMessage = '请填写护照'
          return false;
        } else {
          return true
        }
      }
    },
    nameValidate() {
      //身份证校验
      // eslint-disable-next-line no-unreachable
      let myreg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (myreg.test(this.param.name)) {
        this.nameErrorMessage = '请填写正确的姓名'
        return false;
      } else {
        this.nameErrorMessage = ''
        console.log(this.param.nickname)
        return true;
      }
      if (myreg.test(this.param.nickname)) {
        this.nickNameErrorMessage = '请填写正确的昵称姓名'
        return false;
      } else {
        this.nickNameErrorMessage = ''
        console.log(this.param.nickname)
        return true;
      }
    },
    onSubmit() {
      if (this.param.birthdate == '') {
        Toast.fail('请选择出生日期');
        return
      }
      //密码复杂性验证
      if (this.param.password != '' && this.passComplex) {
        //包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12
        let reg = new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,12}$", "g")
        if (!reg.test(this.param.password)) {
          Dialog({
            message: "密码不符合复杂性要求：包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12",
            theme: 'round-button',
          });
          // Toast.fail('密码不符合复杂性要求：包含数字和字母，以及@#$三种符号，总长度6-8，必须包含2位及以上的字母，必须包含数字');
          return;
        }
      }
      if (this.idvalidate() && this.nameValidate()) {
        this.edit()
      }
    },
    // 时间选择 弹框的确认按钮
    timeFormat() {
      let time = this.date
      this.showAge = false
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      if (month.toString().length == 1) {
        month = '0' + month
      }
      if (day.toString().length == 1) {
        day = '0' + day
      }
      this.param.birthdate = year + '-' + month + '-' + day
    },
    selectArea(e) {
      this.showNative = false
      this.param.natives = e[0].name + e[1].name + e[2].name
    },
  },
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
  display: flex;
  flex-flow: column;
  align-items: center;
}

.footer {
  width: 100%;
}
</style>
